export const API = {
    key: '0e3b9d324de64c529b2152913221004',
    base: 'https://api.weatherapi.com/v1/forecast.json'
}